import React, { useState } from "react";
import InvoiceService from "../../../../AppSettings/services/InvoiceService";
import "./VoidInvoiceModal.css";

interface VoidInvoiceModalProps {
  invoiceId: string;
  displayNumber?: string | number | null;
  onClose: () => void;
  onVoided: () => void;
}

const VoidInvoiceModal: React.FC<VoidInvoiceModalProps> = ({
  invoiceId,
  displayNumber,
  onClose,
  onVoided,
}) => {
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleVoid = async () => {
    setLoading(true);
    setError(null);
    try {
      await InvoiceService.voidInvoice(invoiceId);
      onVoided();
    } catch (err) {
      setError("Failed to void invoice. Please try again.");
      console.error("Void invoice error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="void-modal-overlay" onClick={onClose}>
      <div className="void-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="void-modal-header">
          <h3>Void Invoice #{displayNumber ?? invoiceId}</h3>
        </div>

        <div className="void-modal-body">
          <div className="void-modal-warning">
            <span className="void-modal-warning-icon">⚠</span>
            <div>
              <p className="void-modal-warning-title">This action cannot be undone</p>
              <p className="void-modal-warning-text">
                Voiding this invoice will permanently mark it as VOID. All billing
                entries assigned to this invoice will be unassigned and can be
                applied to a new invoice. The voided invoice will be retained for
                audit purposes.
              </p>
            </div>
          </div>

          <label className="void-modal-checkbox-label">
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              className="void-modal-checkbox"
            />
            I understand this invoice will be permanently voided
          </label>

          {error && <p className="void-modal-error">{error}</p>}
        </div>

        <div className="void-modal-footer">
          <button
            className="void-modal-cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="void-modal-confirm-btn"
            onClick={handleVoid}
            disabled={!confirmed || loading}
          >
            {loading ? "Voiding..." : "Void Invoice"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoidInvoiceModal;
